const undefinedTariffs = () =>
  import(
    /* webpackChunkName: "reports-undefined-tariff" */ '@/pages/report/undefined-tariffs/index.vue'
  )

export default {
  path: 'undefined-tariffs',
  meta: {
    label: 'undefinedTariffs',
    auth: 'undefinedTariff'
  },
  component: {
    name: 'UndefinedTariff',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'furniture/:tariff',
      meta: {
        label: 'report',
        auth: true
      },
      component: undefinedTariffs,
      props: true
    },
    // {
    //   path: 'trash/:tariff',
    //   meta: {
    //     label: 'report',
    //     auth: true
    //   },
    //   component: undefinedTariffs,
    //   props: true
    // },
    {
      path: ':tariff',
      meta: {
        label: 'report',
        auth: true
      },
      component: undefinedTariffs,
      props: true
    }
  ]
}
